import {useState} from 'react'
import {v4} from 'uuid'

export function Select({
  options,
  className = '',
  ...rest
}: React.DetailedHTMLProps<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> & {options: {value: string; text: string}[]}) {
  const [key] = useState(v4())
  return (
    <select {...rest} className={`select ${className}`}>
      {options.map(option => (
        <option key={`${key}-${option.value}`} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  )
}
